import { RequirementConditionType } from 'generated-graphql/types';
import { AutomationFormItem } from 'modules/analyse/types/AutomationFormItem';

export const getAnalysisAutomationScoreMax = (
  analysisAutomationItem: AutomationFormItem
): number | undefined => {
  const condition = analysisAutomationItem.requirementConditions.find(
    (condition) =>
      condition.type === RequirementConditionType.CandidateScoreCondition
  );

  return condition?.scoreScaledMax || undefined;
};
